import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrinterComponent } from './printer/printer.component';

const routes: Routes = [
  {
    path: 'employees',
    loadChildren: () => import('./employees/employees.module').then(m => m.EmployeesModule)
  },
  {
    path: 'offices',
    loadChildren: () => import('./offices/offices.module').then(m =>m.OfficesModule)
  },
  {
    path:'services-admin',
    loadChildren: () => import('./services-admin/services-admin.module').then(m => m.ServicesAdminModule)
  },
  {
    path: 'taxes',
    loadChildren: () => import('./taxes/taxes.module').then(m =>m.TaxesModule)
  },
  {
    path: 'warehouses',
    loadChildren: () => import('./warehouses/warehouses.module').then(m => m.WarehousesModule)
  },
  {
    path: 'setup',
    component: PrinterComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
